var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-ratings"},[_c('MoreTitle',{attrs:{"title":"研报评级"}}),_c('div',{staticClass:"edge-padding"},[_c('VueEcharts',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }